<template>
  <div class="page">
    <!-- 顶部导航栏：返回按钮 + 标题 -->
    <div class="nav-bar">
      <div class="nav-back" @click="goBack">
        <!-- 返回箭头 -->
        <svg viewBox="0 0 24 24">
          <path d="M15 18l-6-6 6-6"/>
        </svg>
      </div>
      <div class="nav-title">购票指南</div>
    </div>

    <!-- 中间提示语：仅供参考 -->
    <div class="notice-bar">各票种截止、开奖时间仅供参考，具体以福彩、体彩官网公告为准</div>

    <!-- 购票指南内容区 -->
    <div class="guide-wrap">
      <div class="guide-card">
        <div class="section-title">各票种销售截止与开奖时间</div>
        <table class="guide-table">
          <thead>
          <tr>
            <th>彩票类型</th>
            <th>票种</th>
            <th>投注截止时间</th>
            <th>开奖时间</th>
          </tr>
          </thead>
          <tbody>
          <template v-for="group in guideList">
            <tr v-for="(item, i) in group.items" :key="group.type + i">
              <!-- 类型列：每组合并为一个单元格 -->
              <td v-if="i === 0" :rowspan="group.items.length" class="type-cell">{{ group.type }}</td>
              <td class="name-cell">{{ item.name }}</td>
              <td>{{ item.deadline }}</td>
              <td>{{ item.drawTime }}</td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>

      <!-- 补充说明 -->
      <div class="guide-card">
        <div class="section-title">说明</div>
        <p class="guide-text">「开奖日」指当期开奖当天，非开奖日不销售对应票种的当期号码。</p>
        <p class="guide-text">截止时间后购买的号码将自动计入下一期。</p>
        <p class="guide-text">如遇法定节假日或官方调整，以彩票发行机构公告为准。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BuyGuideView',
  data() {
    return {
      // 各票种截止与开奖时间：按彩票类型分组，类型列在表格中合并显示
      guideList: [
        {
          items: [
            {name: '快乐8', deadline: '每日 21:00', drawTime: '每日 21:30'},
            {name: '福彩3D', deadline: '每日 20:30', drawTime: '每日 21:15'},
            {name: '双色球', deadline: '开奖日 20:00', drawTime: '每周二、四、日 21:15'},
            {name: '七乐彩', deadline: '开奖日 20:00', drawTime: '每周一、三、五 21:15'}
          ],
          type: '福彩'
        },
        {
          type: '体彩',
          items: [
            {name: '排列三', deadline: '每日 21:00', drawTime: '每日 21:25'},
            {name: '排列五', deadline: '每日 21:00', drawTime: '每日 21:25'},
            {name: '大乐透', deadline: '开奖日 21:00', drawTime: '每周一、三、六 21:25'},
            {name: '七星彩', deadline: '开奖日 21:00', drawTime: '每周二、五、日 21:25'}

          ]
        }
      ]
    }
  },
  methods: {
    goBack() {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
.page {
  width: 100%;
  max-width: 480px;
  min-height: 100%;
  margin: 0 auto;
  background: #f5f6fa;
}

/* ===== 顶部导航栏 ===== */
.nav-bar {
  position: relative;
  height: 48px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-back {
  position: absolute;
  left: 10px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.nav-back svg {
  width: 22px;
  height: 22px;
  fill: none;
  stroke: #fff;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.nav-title {
  color: #fff;
  font-size: 16px;
}

/* ===== 中间提示条：仅供参考 ===== */
.notice-bar {
  margin: 12px 12px 0;
  padding: 10px 12px;
  background: #eef0fb;
  border-radius: 8px;
  text-align: center;
  font-size: 13px;
  color: #909399;
}

/* ===== 指南内容区 ===== */
.guide-wrap {
  padding: 12px;
}

.guide-card {
  background: #fff;
  border-radius: 10px;
  padding: 14px 12px;
}

.guide-card + .guide-card {
  margin-top: 12px;
}

.section-title {
  font-size: 15px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 12px;
  padding-left: 8px;
  border-left: 3px solid #667eea;
}

/* ===== 截止/开奖时间表格 ===== */
.guide-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.guide-table th {
  background: #667eea;
  color: #fff;
  font-weight: bold;
  padding: 8px 6px;
  text-align: center;
  border: 1px solid #667eea;
}

.guide-table td {
  padding: 7px 6px;
  text-align: center;
  border: 1px solid #ebeef5;
  color: #303133;
}

/* 奇数行背景色区分 */
.guide-table tbody tr:nth-child(odd) {
  background: #fafbfc;
}

/* 左侧类型合并单元格：主题色文字突出分组 */
.guide-table .type-cell {
  color: #667eea;
  font-weight: bold;
  background: #f0f2fd;
}

/* 票种列稍宽，左对齐避免名称换行拥挤 */
.guide-table .name-cell {
  text-align: left;
  padding-left: 10px;
  white-space: nowrap;
}

/* ===== 说明文字 ===== */
.guide-text {
  font-size: 13px;
  color: #606266;
  line-height: 1.8;
  margin: 0 0 6px;
}

.guide-text:last-child {
  margin-bottom: 0;
}
</style>
